import React from 'react';
import BookingFlow from '../components/BookingFlow';

export default function DemoBookingPage() {
  return (
    <BookingFlow
      title="Book a Free Demo"
      subtitle="See CoachSight in action — 45-minute live demo, no commitment."
      slotsPath="/demo/slots"
      bookPath="/demo/book"
      backLinkText="← Back"
      submitLabel="Confirm Demo"
      confirmedBackText="← Back to home"
      showCompanyField
    />
  );
}
